import React from 'react';
import { Button, Container, Form, Input } from 'semantic-ui-react';

const ImageForm = (props) => {
    const { handleChange, query, getImages } = props;

    return (
        <Container>
            <h1>Image API</h1>
            <Form size={'large'}>
                <Form.Field
                    control={Input}
                    placeholder='eg. Coffee'
                    id='form-input-control-search'
                    label='Search Image:'
                    value={query}
                    onChange={handleChange}
                />
                <Button
                    primary
                    type='submit'
                    content={'Search'}
                    onClick={getImages}
                />
            </Form>
        </Container>
    )
}

export default ImageForm;